import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Typography,
    Alert
} from '@mui/material';
import { getStatusLabel, getStatusIcon } from '../../utils/orderUtils';

const ChangeStatusModal = ({ open, onClose, onSubmit, count }) => {
    const [status, setStatus] = useState('');

    const handleSubmit = () => {
        if (status) {
            onSubmit(status);
            setStatus(''); // Reset
        }
    };

    const statuses = ['pending', 'confirmed', 'processing', 'shipped', 'delivered', 'cancelled'];

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Changer le statut</DialogTitle>
            <DialogContent>
                <Typography variant="body2" sx={{ mb: 3 }}>
                    Vous allez changer le statut de <strong>{count}</strong> commande(s).
                </Typography>

                <FormControl fullWidth>
                    <InputLabel>Nouveau statut</InputLabel>
                    <Select
                        value={status}
                        label="Nouveau statut"
                        onChange={(e) => setStatus(e.target.value)}
                    >
                        {statuses.map((s) => (
                            <MenuItem key={s} value={s} sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                {/* We could use getStatusIcon here but returns component, so simplified render */}
                                {getStatusLabel(s)}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                {status === 'shipped' && (
                    <Alert severity="info" sx={{ mt: 2 }}>
                        Attention : Passer en "Expédiée" retirera ces commandes des "réservations". Assurez-vous d'avoir géré le stock physique.
                    </Alert>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Annuler</Button>
                <Button onClick={handleSubmit} variant="contained" disabled={!status}>
                    Confirmer
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ChangeStatusModal;
